// extracted by mini-css-extract-plugin
export var tosLink = "_e2-0";